export default {
  'general.logout': 'Connectez - Out',
  'general.sessionExpired': 'Votre session a expiré. Veuillez vous reconnecter.',
  'general.error': 'quelque chose s\'est mal passé',
  'general.reLogin': 'Veuillez vous reconnecter.',
  'general.language': 'Langue',
  'general.language.english': 'Anglaise',
  'general.language.french': 'Française',
  'general.fillMandatory': 'FR Please Fill All Mandatory  Values',
  'general.invalidEmail': 'FR Invalid Email Address',
  'general.scrollToTop': 'Défiler vers le haut.',
  'searchResults.sortBy': 'Trier par',

  'searchResults.filter': 'Filtre',
  'searchResults.filter.date': 'Date',
  'searchResults.filter.date.from': 'De',
  'searchResults.filter.date.to': 'À',
  'searchResults.filter.date.all': 'TOUS',
  'searchResults.filter.applyFiltersButton': 'Appliquer les filtres',

  'searchResults.options': 'Options',
  'searchResults.options.selection': 'Sélection',
  'searchResults.options.selection.selectPage': 'Sélectionner Tout sur la Page',
  'searchResults.options.selection.selectSearch': 'Sélectionner Tout les résultats',
  'searchResults.options.selection.deselectAll': 'Tout désélectionner',
  'searchResults.options.actions': 'Actions',
  'searchResults.options.actionsWorkspaceTitle': 'Espace Actions',
  'searchResults.options.actions.addToWorkspace': 'Ajouter à {workspaceName}',
  'searchResults.options.actions.addToWorkspace.default': 'espace',
  'searchResults.options.actions.removeSelectedFromWorkspace': 'Enlever les sélections de l’espace',
  'searchResults.options.actions.exportAllToExcel':
    'Exporter {selectCount, plural, =0 {tout} other {les objets sélectionnés}} vers Excel (toutes les balises)',
  'searchResults.options.actions.exportTagsToExcel':
    'Exporter {selectCount, plural, =0 {tout} other {les objets sélectionnés}} vers Excel (balises sélectionnées)',
  'searchResults.options.actions.exportToPPT':
    'Exporter {selectCount, plural, =0 {tout} other {les objets sélectionnés}} vers PPT',
  'searchResults.options.actions.exportToZip':
    'Exporter {selectCount, plural, =0 {tout} other {les objets sélectionnés}} vers ZIP',
  'searchResults.options.actions.exportToPDF':
    'Exporter {selectCount, plural, =0 {tout} other {les objets sélectionnés}} vers PDF',
  'searchResults.options.actions.emailAll': 'Tout envoyer par courriel',
  'searchResults.options.actions.relateAllInWorkspace': 'Relier tous les éléments dans l’espace',
  'searchResults.options.actions.umosExpectedError': 'Éléments prévus à trouver',
  'searchResults.options.actions.noUMOsSelected': 'Aucun élément trouvé',
  'searchResults.options.actions.shareAsPortal': 'Partager en tant que portail',
  'searchResults.options.actions.shareExternalPortal': 'Partager en tant que portail externe',
  'searchResults.options.actions.saveToDropbox':
    'Sauvegarder {selectCount, plural, =0 {tout} other {les objets sélectionnés}} vers Dropbox',
  'searchResults.options.actions.resize':
    'Redimensionner {selectCount, plural, =0 {tout} other {les objets sélectionnés}}',
  'searchResults.options.actions.dropboxSaveSuccess': 'Succès! Les fichiers ont été sauvegardés dans votre DropBox',
  'searchResults.options.actions.dropboxSaveError': 'Une erreur est survenue lors de la sauvegarde de vos fichiers dans DropBox',
  'searchResults.compare': 'Comparer',
  'searchResults.copy': 'Copie',
  'searchResults.copy-screen_overlay__message': 'Sélectionner la catégorie de destination',
  'searchResults.copy-screen_overlay__cancel': 'Appuyer sur Échap pour annuler',

  'searchResults.loadingHeader': 'Chargement...',
  'searchResults.previousSearch': 'Back to:',
  'searchResults.previousSearchAdv': 'Advanced Search',
  'searchResults.objectsFoundHeader':
    '{objectsFoundCount} {objectsFoundCount, plural, one {objet} other {objets}} a trouvé',
  'searchResults.objectSelected':
    '{objectsSelectedCount} {objectsSelectedCount, plural, one {objet} other {objets}} sélectionné',

  'categoryDialog.editHeader': 'Éditer la catégorie',
  'categoryDialog.saveButton': 'Sauvegarder',
  'categoryDialog.createChildHeader': 'Ajouter une sous-catégorie',
  'categoryDialog.createButton': 'Créer',
  'categoryDialog.addHeader': 'Ajouter une catégorie',
  'categoryDialog.namePlaceholder': 'Entrer un nom de catégorie',
  'categoryDialog.deleteCheckbox': 'Supprimer cette catégorie',
  'categoryDialog.deleteButton': 'Supprimer',
  'categoryDialog.deleteInProgress': 'Suppression de catégorie en cours',
  'categoryDialog.deleteSuccess': 'Suppression de catégorie réussie',

  'categoryMoveDialog.successMoveMessage': 'Déplacement réussi',
  'categoryMoveDialog.InProgressMoveMessage': 'Déplacement en cours',
  'categoryMoveDialog.successCopyMessage': 'Copie réussie',
  'categoryMoveDialog.InProgressCopyMessage': 'Copie en cours',
  'categoryMoveDialog.moveHeader': 'Déplacer la catégorie',
  'categoryMoveDialog.moveSubtext': 'Sélectionner le nouveau parent pour "{categoryName}"',
  'categoryMoveDialog.cancelButton': 'Annuler',
  'categoryMoveDialog.moveButton': 'Déplacer',

  'messageDialog.dismissAllButton': 'Fermer',

  'metaAttach.attachButton': 'Affecter des métadonnées aux éléments sélectionnés',
  'metaAttach.replaceCheckbox': 'Remplacer les métadonnées (au lieu de les ajouter)',
  'metaAttach.defaultAttachBehavior': 'Défaut : Annexer aux métadonnées',
  'metaAttach.attachArea': 'Ou déposez simplement les éléments ici pour affecter les métadonnées',
  'metaAttach.umosExpectedError': 'Éléments prévus à trouver',
  'metaAttach.genericPartialError':
    'Il y a eu au moins une erreur lors de l’affectation des métadonnées. Veuillez réessayer.',
  'metaAttach.currentValues': 'FR Current Values',
  'metaAttach.editCurValues': 'FR Edit Meta Values',

  'navOptions.setsHeader': 'Éléments marquants',
  'navOptions.workspaceHeader': 'Espaces',
  'navOptions.categoryHeader': 'Catégories',
  'navOptions.adminHeader': 'Admin',
  'navOptions.homeHeader': 'Accueil',
  'navOptions.formsHeader': 'Formulaires',
  'navOptions.thesaurusHeader': 'Thesaurus',

  'navAdminPanel.metaAttach': 'Affectation de métadonnées',
  'navAdminPanel.manageUsers': 'Gestion des utilisateurs',
  'navAdminPanel.usersAndRoles': 'Utilisateurs et rôles',
  'navAdminPanel.adminHeader': 'Admin',
  'navAdminPanel.manageCategoryRoles': 'Gestionnaire des rôles de catégorie',
  'navAdminPanel.publishBtn': 'Publier le(s) média(s)',
  'navAdminPanel.createRelationalBtn': 'FR Add New Record',

  'adminPublish.publishTitle': 'Publier le(s) média(s)',
  'adminPublish.publishBtn': 'COMMENCER',
  'adminPublish.publishBtnTitle': 'Voulez-vous vraiment commencer le processus de synchronisation?',
  'adminPublish.publishBtnStart': 'Lancer la synchronisation',
  'adminPublish.publishBtnCancel': 'Annuler',
  'adminPublish.publishProc.Success': 'Processus de synchronisation commencé avec succès',
  'adminPublish.publishProc.Fail': 'Une erreur s’est produite lors du pousser du ou des médias vers le portail',
  'adminPublish.publishProc.EmptyQueue': 'Rien dans la file d’attente. Tous les actifs sont déjà publiés',
  'adminPublish.publishSubTitle': 'Tous les actifs balisés en conséquence seront publiés vers le portail',

  'navAdminPanel.publishBtnSuccess': 'Média(s) poussé(s) vers le portail avec succès',
  'navAdminPanel.publishBtnFail': 'Une erreur s’est produite lors du pousser du ou des médias vers le portail',
  'navAdminPanel.publishBtnTooltip': 'Cliquer pour publier le(s) média(s) marqué(s) vers le portail public',

  'navCategoryPanel.workspaceToCategoryError': 'Vous ne pouvez pas faire glisser des objets de l’espace dans une catégorie',
  'navCategoryPanel.noEditRoleError': 'Vous n’avez pas la permission de déplacer ou de copier des éléments dans {catName}',
  'navCategoryPanel.noMoveRoleError': 'Vous n’avez pas la permission de déplacer des éléments depuis la catégorie actuelle',
  'navCategoryPanel.categoryHeader': 'Catégories',
  'navCategoryPanel.addCategoryButton': 'Ajouter une catégorie',
  'navCategoryPanel.menuAddChild': 'Ajouter une sous-catégorie',
  'navCategoryPanel.menuUploadToChild': 'Téléverser',
  'navCategoryPanel.menuEditChild': 'Éditer',
  'navCategoryPanel.menuMoveChild': 'Déplacer',

  'navFormsPanel.formHeader': 'Formulaires',

  'navWorkspacePanel.workspaceHeader': 'Espaces',
  'navWorkspacePanel.addWorkspaceButton': 'Ajouter un espace',
  'navWorkspacePanel.menuAddChild': 'Ajouter un sous-espace',
  'navWorkspacePanel.menuEditChild': 'Éditer',

  'navThesaurusPanel.thesaurusHeader': 'Thésaurus',
  'navThesaurusPanel.addTermButton': 'Ajouter un terme',
  'navThesaurusPanel.menuEditChild': 'Éditer',
  'navThesaurusPanel.attachSuccessful': 'Ajouté Avec Succès',

  'thesaurusDialog.editHeader': 'Éditer un terme',
  'thesaurusDialog.saveButton': 'Sauvegarder',
  'thesaurusDialog.createChildHeader': 'Ajouter un sous-terme',
  'thesaurusDialog.createButton': 'Créer',
  'thesaurusDialog.addHeader': 'Ajouter un terme',
  'thesaurusDialog.namePlaceholder': 'Entrer un nom de terme',
  'thesaurusDialog.deleteCheckbox': 'Supprimer ce terme',
  'thesaurusDialog.deleteButton': 'Supprimer',
  'thesaurusDialog.deleteInProgress': 'Suppression en cours',
  'thesaurusDialog.deleteSuccess': 'terme supprimé avec succès',

  'navHighlightsPanel.highlightsHeader': 'Éléments marquants',
  'navHighlightsPanel.addSetButton': 'Ajouter un ensemble d’éléments marquants',
  'navHighlightsPanel.menuEditChild': 'Éditer',

  'pagination.previousButton': 'Précédent',
  'pagination.pageNumberOfTotal': 'de {pageTotal}', // i.e "2 of 3"
  'pagination.nextButton': 'Prochain',

  'panelTree.noItemsMessage': 'Aucun élément à afficher',

  'searchBar.defaultSearch': 'Recherche par défaut',
  'searchBar.advancedSearch': 'Recherche avancée',
  'searchBar.advancedButton': 'AVANCÉE',
  'searchBar.advanced.defaultCollectionLabel': 'Sélectionner le groupe de métadonnées',
  'searchBar.advanced.selectCollectionPlaceholder': 'Sélectionner une collection',
  'searchBar.advanced.collectionsRetrieveError': 'Une erreur s’est produite. Cliquez pour réessayer',
  'searchBar.advanced.mediaType': 'Sélectionner une Media Type',
  'searchBar.advanced.addMetatagButton': 'Ajouter une métabalise',
  'searchBar.advanced.searchButton': 'Recherche',
  'searchBar.advanced.clearButton': 'Effacer',
  'searchBar.advancedForm.operatorAnd': 'ET',
  'searchBar.advancedForm.operatorOr': 'OU',
  'searchBar.advancedForm.operatorNot': 'NON',
  'searchBar.advancedForm.anyMetatagOption': 'N’importe quelle métabalise',
  'searchBar.advancedForm.searchTermPlaceholder': 'Terme de recherche',
  'searchBar.advanced.saveSearch': 'Sauvegarder la recherche',
  'searchBar.advanced.savedSearches': 'Recherches sauvegardées',
  'searchBar.advanced.searchNameMissing': 'Nom de recherche manquant',
  'searchBar.advanced.searchSaveError': 'Une erreur est survenue lors de la tentative de sauvegarde de votre recherche',
  'searchBar.advanced.deleteSearchButton': 'Supprimer {searchName}',
  'searchBar.advanced.saveSearchExists': 'Le nom existe déjà',
  'searchBar.advanced.specificCollection': 'FR Search Current Collection Only',

  'searchBar.simple.searchPlaceholder': 'Rechercher',
  'searchBar.simple.typeAny': 'N’importe',
  'searchBar.simple.typeImage': 'Image',
  'searchBar.simple.typeVideo': 'Vidéo',
  'searchBar.simple.typeAudio': 'Audio',
  'searchBar.simple.typeDocument': 'Document',
  'searchBar.simple.typeRecord': 'Enregistrement',

  'umoDetailView.requestUMOError': 'Aucun OMU trouvé',
  'umoDetailView.primaryImageLabel': 'Il s’agit de l’image principale',
  'umoDetailView.setAsPrimaryButton': 'Cliquer pour établir cette image comme image principale.',
  'umoDetailView.setAsPrimaryWarningMessage': 'Voulez-vous vraiment utiliser cette image comme image principale?',
  'umoDetailView.addToWorkspaceButton': 'Ajouter à {workspaceName}',
  'umoDetailView.addToWorkspaceGenericButton': 'Ajouter à l’espace',
  'umoDetailView.DownloadImageButton': 'Téléchargements',
  'umoDetailView.DownloadViewedImageTooltip': 'Télécharger l’image affichée',
  'umoDetailView.metadataHeader': 'Métadonnées',
  'umoDetailView.relatedItemHeader': 'Éléments liés:',

  'umoCardView.save': 'Sauvegarder',
  'umoCardView.dueDate': 'Échéance',
  'umoCardView.status': 'Statut',
  'umoCardView.delete': 'Supprimer',
  'umoCardView.deleteCard': 'Supprimer la carte',
  'umoCardView.newComment': 'Nouvelle',
  'umoCardView.edit': 'Éditer',
  'umoCardView.edited': '(Édité)',
  'umoCardView.cancel': 'Annuler',
  'umoCardView.attachments': 'Pièces jointes',
  'umoCardView.uploading': 'Téléversement en cours',
  'umoCardView.comments': 'Commentaires',
  'umoCardView.description': 'Description',
  'umoCardView.addComment': 'Ajouter un commentaire',
  'umoCardView.noAttachments': 'Rien n’est joint encore',
  'umoCardView.submit': 'Envoyer',
  'umoCardView.commentBy': 'Commentaire par {name}',
  'umoCardView.getCardError': 'Une erreur s’est produite lors de l’obtention des données sur la carte',
  'umoCardView.delCommentError': 'Une erreur s’est produite lors de la tentative de suppression du commentaire',
  'umoCardView.delAttachmentError': 'Une erreur s’est produite lors de la tentative de suppression de la pièce jointe',
  'umoCardView.delCardError': 'Une erreur s’est produite lors de la tentative de suppression de la carte',
  'umoCardView.delCardVerify': 'Voulez-vous vraiment supprimer cette carte?',
  'umoCardView.delCommentUndo': 'Annuler la suppression du commentaire',
  'umoCardView.delFileUndo': 'Annuler la suppression du fichier',
  'umoCardView.undo': 'Annuler',
  'umoCardView.uploadFileError': 'Une erreur s’est produite lors de la tentative de téléchargement du fichier',
  'umoCardView.addCommentError': 'Une erreur s’est produite lors de la tentative de sauvegarde du commentaire',
  'umoCardView.inCategory': 'Dans {catName}',
  'umoCardView.tabGeneral': 'Général',
  'umoCardView.tabComments': 'Commentaires',
  'umoCardView.tabMetadata': 'Métadonnées',
  'umoCardView.tabHistory': 'histoire',
  'umoCardView.historyID': 'ID',
  'umoCardView.historyName': 'Nom',
  'umoCardView.historyDetails': 'Détails',
  'umoCardView.historyDate': 'Date',
  'umoCardView.historyNone': 'Pas d`historique sur l`élément',

  'umoGridItem.relatedItemTagLabel': 'Éléments liés',
  'umoGridItem.relatedItemTagDescription': 'Éléments liés apparentés',
  'umoGridItem.alternateItemTagLabel': 'Substituts',
  'umoGridItem.alternateItemTagDescription': 'Autres images pour l’image principale',
  'umoGridItem.addToWorkspaceTooltip': 'Ajouter à "{workspaceName}"',
  'umoGridItem.selectWorkspaceTooltip': 'Veuillez sélectionner un espace',
  'umoGridItem.reportImageTooltip': 'Signaler un ou des médias',
  'umoGridItem.viewDetailsButton': 'Afficher les détails',
  'umoGridItem.menuEditMetaData': 'Éditer les métadonnées',
  'umoGridItem.menuCrop': 'Recadrer',
  'umoGridItem.menuImageAnnotator': 'Annotateur de image',
  'umoGridItem.menuResize': 'Redimensionner',
  'umoGridItem.menuVideoAnnotator': 'Annotateur de vidéo',
  'umoGridItem.menuVideoSnippet': 'Extrait de vidéo',
  'umoGridItem.menuViewPeers': 'Afficher les éléments apparentés',
  'umoGridItem.menuEditMeta': 'Éditer les métadonnées',
  'umoGridItem.menuNoDownloadsAvailableMessage': 'Aucun téléchargement disponible',
  'umoGridItem.toolsHeader': 'Outils',
  'umoGridItem.menuDownloadsHeader': 'Téléchargements',
  'umoGridItem.menuRelatedImagesHeader': 'Images liées',

  'umoListItem.fileName': 'Nom du Fichier',
  'umoListItem.type': 'Type',
  'umoListItem.size': 'Taille du Fichier',
  'umoListItem.height': 'Hauteur (px)',
  'umoListItem.width': 'Largeur (px)',
  'umoListItem.duration': 'Durée',
  'umoListItem.dateCreated': 'Date de Chargement',

  'workspace.dropRestrictionError':
    'Vous ne pouvez faire glisser les objets des espaces que d’un espace à un sub-espace.',

  'workspaceDialog.editWorkspaceHeader': 'Éditer l’espace',
  'workspaceDialog.saveButton': 'Sauvegarder',
  'workspaceDialog.attachments': 'Pièces jointes',
  'workspaceDialog.addChildWorkspaceHeader': 'Ajouter un sous-espace',
  'workspaceDialog.createButton': 'Créer',
  'workspaceDialog.addWorkspaceHeader': 'Ajouter un espace',
  'workspaceDialog.shareLabel': 'Partager',
  'workspaceDialog.sharePlaceholder': 'Sélectionnez les utilisateurs avec lesquels vous partagerez votre espace',
  'workspaceDialog.shareRemoveAll': 'Tout supprimer',
  'workspaceDialog.nameLabel': 'Nom',
  'workspaceDialog.namePlaceholder': 'Entrer le nom de l’espace',
  'workspaceDialog.descriptionLabel': 'Description',
  'workspaceDialog.descriptionPlaceholder': 'Entrer la description de l’espace',
  'workspaceDialog.deleteButton': 'Supprimer',
  'workspaceDialog.cancelButton': 'Annuler',
  'workspaceDialog.deleteWorkspace': 'La suppression de cet espace de travail entraînera celle de tous les sous-espaces. Ce processus pourrait prendre quelques instants.',
  'workspaceDialog.deleteSuccess': 'Suppression de l’espace de travail réussie',
  'workspaceDialog.nameExists': 'Il y a déjà un espace de travail du même nom',
  'workspaceDialog.errorOccurred': 'Une erreur s’est produite lors de la sauvegarde de votre espace de travail',


  'mainDialog.title': 'FR Share Links',
  'mainDialog.subTitle': 'FR Share media item {umoName}',
  'mainDialog.copy': 'FR Copied!',
  'mainDialog.copyTooltip': 'FR Copy to Clipboard',

  'highlightSetDialog.editWorkspaceHeader': 'Éditer un ensemble d’éléments marquants',
  'highlightSetDialog.saveButton': 'Pièces jointes',
  'highlightSetDialog.createButton': 'Créer',
  'highlightSetDialog.addWorkspaceHeader': 'Ajouter un ensemble d’éléments marquants',
  'highlightSetDialog.nameLabel': 'Nom',
  'highlightSetDialog.namePlaceholder': 'Entrer le nom de l’ensemble',
  'highlightSetDialog.descriptionLabel': 'Description',
  'highlightSetDialog.descriptionPlaceholder': 'Entrer la description de l’ensemble',
  'highlightSetDialog.deleteButton': 'Supprimer',
  'highlightSetDialog.cancelButton': 'Annuler',
  'highlightSetDialog.deleteSuccess': 'Ensemble supprimé avec succès',
  'highlightSetDialog.nameExists': 'Il y a déjà un ensemble du même nom',
  'highlightSetDialog.errorOccurred': 'Une erreur s’est produite lors de la sauvegarde de votre ensemble',

  'workspaceEmailDialog.emailSentSuccessMessage': 'Envoi du courriel réussi',
  'workspaceEmailDialog.emailWorkspaceHeader': 'Envoyer l’espace par courriel',
  'workspaceEmailDialog.emailWorkspaceSubtext': 'Utilisez ce formulaire pour envoyer le contenu de cet espace par courriel',
  'workspaceEmailDialog.emailWorkspacePortal': 'Utilisez ce formulaire pour créer un compte temporaire doté d’un accès à cet espace de travail.',
  'workspaceEmailDialog.namePlaceholder': 'Votre nom',
  'workspaceEmailDialog.accountNamePlaceholder': 'Nom du compte',
  'workspaceEmailDialog.toEmailPlaceholder': 'Adresse des destinataires',
  'workspaceEmailDialog.toEmailSubtext': 'Utilisez une virgule ou un point-virgule pour séparer les adresses',
  'workspaceEmailDialog.messagePlaceholder': 'Message',
  'workspaceEmailDialog.cancelButton': 'Annuler',
  'workspaceEmailDialog.sendButton': 'Envoyer',
  'workspaceEmailDialog.DMZMessage': 'FR It might take a few minutes for all items to appear in the DMZ workspace',

  'workspaceResizeDialog.mainTitle': 'Redimensionner les images',
  'workspaceResizeDialog.optionsTitle': 'Options de redimensionnement',
  'workspaceResizeDialog.optionsType': 'Type',
  'workspaceResizeDialog.optionsWidth': 'Largeur',
  'workspaceResizeDialog.optionsDPI': 'DPI',
  'workspaceResizeDialog.optionsQuality': 'Qualité',
  'workspaceResizeDialog.optionsEmbedMetadata': 'Incorporer les métadonnées {xmp}',
  'umoModifyDialog.buttonCancel': 'Annuler',
  'umoModifyDialog.buttonApply': 'Appliquer',
  'umoModifyDialog.tabResize': 'Redimensionner',
  'umoModifyDialog.tabCrop': 'Recarder',
  'umoModifyDialog.tabCopy': 'Copier',
  'umoModifyDialog.tabRotate': 'Faire Pivoter',
  'umoModifyDialog.inProgressMessage': 'Ce processus peut prendre un certain temps. Il se poursuivra en arrière-plan.',
  'workspaceDownloadDialog.buttonDownload': 'Téléchargements',
  'workspaceDownloadDialog.mainTitle': 'Télécharger le(s) média(s)',
  'workspaceDownloadDialog.emailDownload': 'FR This item will be sent to the email address you have provided',
  'workspaceDownloadDialog.emailDynamicDownload': 'FR This item is dynamically generated and will be sent to the email address you provide',
  'workspaceDownloadDialog.optionsTitle': 'Télécharger le contenu de l’espace de travail dans un fichier ZIP',
  'workspaceDownloadDialog.pdfDownloadTitle': 'Créer un PDF avec le contenu de l’espace de travail',
  'workspaceDownloadDialog.optionsSubTitle': 'Choisir le dérivé pour chaque type de média',
  'workspaceDownloadDialog.optionsPhoto': 'Image',
  'workspaceDownloadDialog.optionsVideo': 'Vidéo',
  'workspaceDownloadDialog.optionsAudio': 'Audio',
  'workspaceDownloadDialog.optionsDocuments': 'Document',
  'workspaceDownloadDialog.optionsItemsPerPage': 'Choisir le nombre d’éléments par page',

  'workspacePreview.workspaceDetailsButton': 'Détails sur l’espace',
  'workspacePreview.options': 'Options',
  'workspacePreview.selection': 'Sélection',
  'workspacePreview.selection.selectAll': 'Tout sélectionner',
  'workspacePreview.selection.deselectAll': 'Tout désélectionner',
  'workspacePreview.actions': 'Actions',
  'workspacePreview.actions.removeSelectedFromWorkspace': 'Enlever les éléments sélectionnés de l’espace',

  'utils.piction.moveCategoryGenericError': 'Une erreur inconnue s’est produite. Veuillez réessayer.',
  'utils.piction.moveCategoryPermissionError': 'Vous n’avez pas les permissions pour déplacer des éléments dans la catégorie sélectionnée',

  'metadataView.noMetadata': 'Il n’y a pas de métadonnées disponibles pour l’OMU sélectionné',

  'newRelational.addNewRelational': 'FR Add New Record',
  'newRelational.configErr': 'FR Configuration Error.',
  'newRelational.contactAdminMsg': 'FR Contact your system admin to use this feature',
};



// WEBPACK FOOTER //
// ./src/translations/fr.js